<template>
    <div class="p-15">
        <div class="tb-column-center bg-white" v-if="sealDetail.state == 0 || sealDetail.state == undefined">
            <Steps :current="step" class="m-b-20 p-25">
                <Step title="录入信息"></Step>
                <Step title="付款"></Step>
            </Steps>
        </div>

        <div class="m-t-20 bg-white p-t-60 p-b-60 p-l-20 p-r-20">
            <div v-if="step == 0">
                <Form :model="sealDetail" ref="sealForm" label-position="right" :label-width="110" :rules="rules">
                    <Row :gutter="20">
                        <Col span="12">
                            <Checkbox v-model="knowSiCode" class="m-l-25 m-b-20" @on-change="changeCheck">我知道印章编码
                            </Checkbox>
                            <FormItem label="单位名称：" prop="siOrgName" v-show="!knowSiCode">
                                <Input v-model="sealDetail.siOrgName" placeholder="请输入单位名称" style="width:100%"></Input>
                            </FormItem>
                            <FormItem label="印章编码：" prop="siCode" v-show="knowSiCode">
                                <Input v-model="sealDetail.siCode" placeholder="请输入印章编码" style="width:100%"></Input>
                            </FormItem>
                            <FormItem label="信用代码：" prop="siOrgUscc" v-show="!knowSiCode">
                                <Input v-model="sealDetail.siOrgUscc" placeholder="请输入信用代码" style="width:100%"></Input>
                            </FormItem>
                            <FormItem label="印章类型：" prop="siSealType" v-show="!knowSiCode">
                                <Dict v-model="sealDetail.siSealType" dict="DictSocietySealsite_sealType"
                                      placeholder="请选择印章类型" style="width:100%"></Dict>
                            </FormItem>
                            <FormItem label="上传参考图像：" prop="dzImgImpressionOss">
                                <PhotoUpload v-model="sealDetail.dzImgImpressionOss"
                                             :success="dzImgImpressionOssSuccess"></PhotoUpload>
                                <!-- <div class="tb-row">
                                    <img :src="sealImgUrl" width="58" height="58" v-if="sealImgUrl.length > 0">
                                    <Upload class="m-l-10 b-1 tb-column-center" :action="upload.action" :on-success="upload.success" :data="upload.param" :show-upload-list="false" style="width: 58px; height: 58px; line-height: 58px;">
                                        <i class="ivu-icon ivu-icon-camera f-20"></i>
                                    </Upload>
                                </div> -->
                            </FormItem>
                        </COL>
                        <Col span="12">
                            <FormItem :label="sealDetail.settleState > 0?'已选key类型：':'选择key类型：'">
                                <div v-show="sealDetail.settleState > 0">
                                    <div class="tb-row w-50 w-200-px b-1 m-r-30">
                                        <img :src="keyActive == '01'?'img/dzNormal.jpg':'img/dzYejing.jpg'"
                                             class="w-80-px h-80-px m-10">
                                        <div class="tb-column tb_justify-center w-110-px">
                                            <div><span
                                                    v-dict:DictSocietySealsite_sealDzType="sealDetail.dzDeviceType"></span>
                                            </div>
                                            <div>{{keyActive == '01'?'￥380':'￥480'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </FormItem>
                            <div class="tb-row" v-show="!(sealDetail.state > 0)">
                                <div v-for="(item, index) in sealDzTypeList" :key="index"
                                     class="tb-row w-200-px b-1 m-r-20" :class="{'boxShadow': keyActive == index}"
                                     @click="keyActive = index">
                                    <img :src="index == '01'?'img/dzNormal.jpg':'img/dzYejing.jpg'"
                                         class="w-80-px h-80-px m-10">
                                    <div class="tb-column tb_justify-center w-110-px">
                                        <div>{{item}}</div>
                                        <div>{{index == '01'?'￥380':'￥480'}}</div>
                                    </div>

                                    <div><img class="w-32-px" src="img/yixuan.png" v-if="keyActive == index"></div>
                                </div>
                            </div>
                            <FormItem label="填写快递信息：" class=" m-t-20">
                            </FormItem>
                            <div v-show="eSeal.deliverType == 'method1'">
                                <FormItem label="省市区：" prop="deliverDist6">
                                    <TuboDist v-model="sealDetail.deliverDist6" placeholder="请选择省市区" dict-name="dist.support"
                                              style="width:100%"></TuboDist>
                                </FormItem>
                                <FormItem label="收件人姓名：" prop="deliverPersonName">
                                    <Input v-model="sealDetail.deliverPersonName" placeholder="请输入收件人姓名"
                                           style="width:100%"></Input>
                                </FormItem>
                                <FormItem label="收件人电话：" prop="deliverPersonPhone">
                                    <Input v-model="sealDetail.deliverPersonPhone" placeholder="请输入收件人电话"
                                           style="width:100%"></Input>
                                </FormItem>
                                <FormItem label="详细地址：" prop="deliverAddress">
                                    <Input v-model="sealDetail.deliverAddress" placeholder="请输入详细地址"
                                           style="width:100%"></Input>
                                </FormItem>
                            </div>
                        </COL>
                    </Row>
                </Form>

                <div v-show="sealDetail.state >= 1" style="width:50%">
                    <Group title="支付信息" :titleMarginStyle="'margin-left:90px'">
                        <Cell title="支付方式："><span v-dict:DictStd_payType="sealDetail.payType"></span></Cell>
                        <Cell title="支付金额：" :value="sealDetail.settlePriceRetail"></Cell>
                        <Cell title="付款时间：" :value="sealDetail.dzPaidDate"></Cell>
                    </Group>
                </div>

                <div class="tb-row-center">
                    <Button type="primary" @click="cancel"
                            v-show="sealDetail.state == 0 || sealDetail.state == undefined">取消
                    </Button>
                    <Button type="primary" class="m-l-15" @click="saveEseal"
                            v-show="sealDetail.state == 0 || sealDetail.state == undefined">下一步
                    </Button>
                </div>
            </div>

            <div v-if="step == 1">
                <div class="w-70" style="margin:0 15%">
                    <div class="f-16 c-gray-dark" style="font-weight:700;">支付金额￥{{sealDetail.settlePriceRetail}}</div>
                    <div class="tb-row">
                        <div class="m-t-20 ti-g-1">
                            <div class="f-700">微信：</div>
                            <div class="m-l-80">
                                <img src="img/weixin2.png">
                                <div>
                                    <Button class="m-t-20"
                                            @click="modal.show = true,modal.type = 1,sealDetail.payType = 1,polling()">
                                        去支付
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-20 ti-g-1">
                            <div class="f-700">支付宝：</div>
                            <div class="m-l-80">
                                <img src="img/zhifubao2.png">
                                <div @click="modal.show = true,modal.type = 2,sealDetail.payType = 0" class="m-t-20">
                                    <a :href="eSealPay.eSealAliPayUrl" target="_blank">
                                        <Button @click="polling()">去支付</Button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tb-row-center m-t-60">
                    <Button type="primary" class="m-l-15" @click="preStep">上一步</Button>
                </div>
            </div>
        </div>

        <Modal v-model="modal.show" :title="modal.type == 2?'支付宝付款':'微信付款'" ok-text="关闭" cancel-text=""
               @on-cancel="cancelPay" @on-ok="cancelPay">
            <div class="tb-column-center">
                <img :src="eSealPay.eSealWxPaySan" v-if="sealDetail.payType == 1">
                <div v-else>请在新打开的支付宝窗口进行付款</div>
                <div>支付金额：{{sealDetail.settlePriceRetail}}</div>
            </div>
        </Modal>

        <Modal v-model="extendModal.show" title="扩展信息" :width="1000" ok-text="确定" cancel-text="">
            <Form :model="sealDetail" label-position="right" :label-width="180" class="p-l-30 p-r-30">
                <h4 class="m-b-10">备案公安单位信息</h4>
                <div class="tb-row">
                    <FormItem label="备案单位编码：" class="ti-g-1">
                        <Input v-model="sealDetail.supervisorCode" placeholder="请输入备案单位编码"></Input>
                    </FormItem>
                    <FormItem label="备案单位名称：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.supervisorName" placeholder="请输入备案单位名称"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="备案日期：" class="ti-g-1">
                        <DateTime class="w-100" :transfer="true" type="datetime" v-model="sealDetail.siDatePermit"
                                  format="yyyy-MM-dd" placeholder="请输入备案日期"></DateTime>
                    </FormItem>
                    <FormItem label="备案人：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.supervisorPersonName" placeholder="请输入备案人"></Input>
                    </FormItem>
                </div>
                <div class="m-t-10 m-b-10" style="width: 100%; height: 1px; background: rgb(221, 221, 221);"></div>
                <h4 class="m-b-10">制作单位信息</h4>
                <div class="tb-row">
                    <FormItem label="制作单位编码：" class="ti-g-1">
                        <Input v-model="sealDetail.makerCode" placeholder="请输入制作单位编码"></Input>
                    </FormItem>
                    <FormItem label="制作单位名称：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.makerName" placeholder="请输入制作单位名称"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="承接日期：" class="ti-g-1">
                        <DateTime class="w-100" :transfer="true" type="datetime" v-model="sealDetail.societyDateAccept"
                                  format="yyyy-MM-dd" placeholder="请输入备案日期"></DateTime>
                    </FormItem>
                    <FormItem label="制作日期：" class="ti-g-1 m-l-20">
                        <DateTime class="w-100" :transfer="true" type="datetime" v-model="sealDetail.societyDateMade"
                                  format="yyyy-MM-dd" placeholder="请输入备案日期"></DateTime>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="制作单位名称（英文）：" class="ti-g-1">
                        <Input v-model="sealDetail.makerNameEng" placeholder="请输入制作单位编码"></Input>
                    </FormItem>
                    <FormItem label="制作单位名称（少数民族）：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.makerNameFolk" placeholder="请输入制作单位名称"></Input>
                    </FormItem>
                </div>
                <div class="m-t-10 m-b-10" style="width: 100%; height: 1px; background: rgb(221, 221, 221);"></div>
                <h4 class="m-b-10">使用单位信息</h4>
                <div class="tb-row">
                    <FormItem label="使用单位编码：" class="ti-g-1">
                        <Input v-model="sealDetail.orgCode" placeholder="请输入使用单位编码"></Input>
                    </FormItem>
                    <FormItem label="使用单位名称：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.siOrgName" placeholder="请输入使用单位名称"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="使用单位名称（英文）：" class="ti-g-1">
                        <Input v-model="sealDetail.siOrgNameEng" placeholder="请输入使用单位编码"></Input>
                    </FormItem>
                    <FormItem label="使用单位名称（少数民族）：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.siOrgNameFolk" placeholder="请输入使用单位名称"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="使用单位法人：" class="ti-g-1">
                        <Input v-model="sealDetail.crpName" placeholder="请输入使用单位编码"></Input>
                    </FormItem>
                    <FormItem label="使用单位法人身份证号码：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.crpCertNo" placeholder="请输入使用单位法人身份证号码"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="单位类型：" class="ti-g-1">
                        <Dict :transfer="true" v-model="sealDetail.orgType" dict="DictSocietySealsite_orgType"
                              placeholder="单位类型" :clearable="true"></Dict>
                    </FormItem>
                    <FormItem label="社会统一信用代码：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.orgUscc" placeholder="请输入社会统一信用代码"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="经办人：" class="ti-g-1">
                        <Input v-model="sealDetail.opName" placeholder="请输入经办人"></Input>
                    </FormItem>
                    <FormItem label="经办人身份证号码：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.opCertNo" placeholder="请输入经办人身份证号码"></Input>
                    </FormItem>
                </div>
                <div class="m-t-10 m-b-10" style="width: 100%; height: 1px; background: rgb(221, 221, 221);"></div>
                <h4 class="m-b-10">其他信息</h4>
                <div class="tb-row">
                    <FormItem label="章面材料：" class="ti-g-1">
                        <Dict :transfer="true" v-model="sealDetail.sealMatType" dict="DictSocietySealsite_sealMatType"
                              placeholder="章面材料" :clearable="true"></Dict>
                    </FormItem>
                    <FormItem label="印油说明：" class="ti-g-1 m-l-20">
                        <Input v-model="sealDetail.sealOilDesc" placeholder="请输入印油说明"></Input>
                    </FormItem>
                </div>
                <div class="tb-row">
                    <FormItem label="状态：" class="ti-g-1">
                        <span v-dict:EntityGzwDzSeal_state="sealDetail.state"></span>
                    </FormItem>
                </div>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import store from '@/modules'
    import {api, dict} from '@/libs'
    import {mapState} from 'vuex'
    import {TuboDist} from "@/components/libs";

    export default {
      components: {TuboDist},
      data() {
            const _this = this
            return {
                step: 0,
                typeActive: 0,
                sealForm: {},
                showTabs: false,
                knowSiCode: false,
                rules: {
                    siOrgName: [{required: true, trigger: 'blur', message: '请输入单位名称'}],
                    siOrgUscc: [{required: true, trigger: 'blur', message: '请输入信用代码'}],
                    siSealType: [{required: true, trigger: 'change', message: '请选择印章类型'}],
                    deliverDist6: [{required: true, trigger: 'change', message: '请选择省市区'}],
                    deliverPersonName: [{required: true, trigger: 'blur', message: '请输入收件人姓名'}],
                    deliverPersonPhone: [{required: true, trigger: 'blur', message: '请输入收件人电话'}],
                    deliverAddress: [{required: true, trigger: 'blur', message: '请输入详细地址'}]
                },
                firstRules: {
                    siOrgName: [{required: true, trigger: 'blur', message: '请输入单位名称'}],
                    siOrgUscc: [{required: true, trigger: 'blur', message: '请输入信用代码'}],
                    siSealType: [{required: true, trigger: 'change', message: '请选择印章类型'}],
                    deliverDist6: [{required: true, trigger: 'change', message: '请选择省市区'}],
                    deliverPersonName: [{required: true, trigger: 'blur', message: '请输入收件人姓名'}],
                    deliverPersonPhone: [{required: true, trigger: 'blur', message: '请输入收件人电话'}],
                    deliverAddress: [{required: true, trigger: 'blur', message: '请输入详细地址'}]
                },
                secondRules: {
                    siCode: [{required: true, trigger: 'blur', message: '请输入印章编码'}],
                    deliverDist6: [{required: true, trigger: 'change', message: '请选择省市区'}],
                    deliverPersonName: [{required: true, trigger: 'blur', message: '请输入收件人姓名'}],
                    deliverPersonPhone: [{required: true, trigger: 'blur', message: '请输入收件人电话'}],
                    deliverAddress: [{required: true, trigger: 'blur', message: '请输入详细地址'}]
                },
                eSeal: {
                    deliverType: 'method1'
                },
                modal: {
                    show: false
                },
                extendModal: {
                    show: false
                },
                eSealWxPaySan: '',
                eSealAliPayUrl: '',
                sealImgUrl: '',
                checkState: {},
                keyActive: null,
                payTypeList: [],
                sealDzTypeList: [],
                siSpecList: ['20/20', '29/29', '30/30', '32/32', '35/35', '36/36', '38/38', '40/30', '40/40', '42/42', '44/44', '45/45', '50/50'],
                cv3ImgUrl: '',
                originalImgUrl: '',
                typesetImgUrl: '',
                typesetOriginalImgUrl: '',
                thresholdList: [80, 130, 140, 150, 160, 170, 180, 190, 200, 210],
                ratioList: ['200DPI', '300DPI', '400DPI', '600DPI'],
                thresholdActive: 4,
                ratioActive: 3,
                thresholdNow: 170,
                ratioNow: 300,
                md5Now: '',
                upload: {
                    action: 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img',
                    param: {
                        imageType: 'SCAN'
                    },
                    fileUploadSuccessCall(payload, file, fileList) {
                        _this.md5Now = payload.md5
                        _this.cv3ImgUrl = 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img/' + payload.md5 + '?format=' + 'trans.png' + '&version=' + new Date().getTime()
                        _this.originalImgUrl = 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img/' + payload.md5 + '?format=' + 'jpg' + '&version=' + new Date().getTime()
                        _this.$forceUpdate()
                    }
                },
                uploadTypeset: {
                    action: 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img',
                    param: {
                        imageType: 'TYPESET'
                    },
                    fileUploadSuccessCall(payload, file, fileList) {
                        _this.md5Now = payload.md5
                        _this.typesetOriginalImgUrl = 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img/' + payload.md5 + '?format=' + 'png'
                        _this.typesetImgUrl = 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img/' + payload.md5 + '?format=' + 'trans.png'
                        _this.$forceUpdate()
                    }
                }
            }
        },
        computed: {
            ...mapState({
                sealDetail: state => state.clientGzwOrder.sealDetail
            }),
            eSealPay() {
                if (this.sealDetail && this.sealDetail.id && this.sealDetail.state == 0) {
                    return {
                        eSealWxPaySan: api.baseUrl + api.gzwCusDz.dzPayWxScan + this.sealDetail.id + '?token=' + localStorage.getItem('pcCustomToken'),
                        eSealAliPayUrl: api.baseUrl + api.gzwCusDz.dzPayAlipayPc + this.sealDetail.id + '?token=' + localStorage.getItem('pcCustomToken')
                    }
                } else return {eSealWxPaySan: '', eSealAliPayUrl: ''}
            },
        },
        methods: {
            dzImgImpressionOssSuccess(data) {
            },
            changeCheck(code) {
                if (code) this.rules = Object.assign({}, this.secondRules)
                else this.rules = Object.assign({}, this.firstRules)
                this.$forceUpdate()
            },
            cancel() {
                this.$router.push({path: '/center/eSeal/eSealCurrent'})
            },
            preStep() {
                this.$router.push({
                    path: this.$route.path,
                    query: {id: this.sealDetail.id ? this.sealDetail.id : '', step: this.step - 1}
                })
                this.step = this.step - 1
            },
            nextStep() {
                this.$router.push({
                    path: this.$route.path,
                    query: {id: this.sealDetail.id ? this.sealDetail.id : '', step: this.step + 1}
                })
                this.step = this.step + 1
            },
            queryData() {
                this.$store.dispatch('clientGzwOrder/querySealContent', {code: this.sealDetail.code}).then(() => {
                    this.$store.dispatch('clientGzwOrder/querySealOrg', {code: this.sealDetail.orgCode}).then(() => this.$forceUpdate())
                })
            },
            saveEseal() {
                if (this.keyActive == null) {
                    this.$Notice.error({desc: '请选择key类型'})
                    return
                }
                this.$refs.sealForm.validate((valid) => {
                    if (valid) {
                        this.sealDetail.deliverType = this.eSeal.deliverType == 'method1' ? '01' : '02'
                        if (this.sealDetail.deliverType == '02') Object.assign(this.sealDetail, {
                            deliverDist6: '',
                            deliverPersonName: '',
                            deliverPersonPhone: '',
                            deliverAddress: ''
                        })
                        this.sealDetail.dzDeviceType = this.keyActive
                        if (this.$route.query.id) {
                            this.$store.dispatch('clientGzwOrder/editEseal', {
                                id: this.$route.query.id,
                                dzSealJson: this.sealDetail
                            }).then(() => {
                                this.$router.push({
                                    path: this.$route.path,
                                    query: {id: this.sealDetail.id ? this.sealDetail.id : '', step: 1}
                                })
                                this.step = 1
                            })
                        } else {
                            this.$store.dispatch('clientGzwOrder/addEseal', {dzSealJson: this.sealDetail}).then(() => {
                                this.$router.push({
                                    path: this.$route.path,
                                    query: {id: this.sealDetail.id ? this.sealDetail.id : '', step: 1}
                                })
                                this.step = 1
                            })
                        }
                    }
                })
            },
            accept() {
                const _this = this
                this.$Modal.confirm({
                    title: "受理印章",
                    content: "是否受理此印章?",
                    onOk() {
                        _this.$store.dispatch('clientGzwOrder/editEseal', {
                            id: _this.$route.query.id,
                            dzSealJson: _this.sealDetail
                        }).then(() => {
                            _this.$store.dispatch('clientGzwOrder/opAccept', {id: _this.sealDetail.id}).then(() => _this.$router.push({path: '/center/eSeal/eSealDeal'}))
                        })
                    }
                })
            },
            cancelPay() {
                clearInterval(this.checkState)
            },
            polling() {
                const _this = this
                this.checkState = setInterval(() => {
                    store.dispatch('clientGzwOrder/getSealDetail', {
                        id: _this.$route.query.id
                    })
                    if (_this.sealDetail.settleState === '1') {
                        clearInterval(this.checkState)
                        _this.$router.push({path: '/center/eSeal/eSealCurrent'})
                        window.location.reload()
                    }
                }, 1000)
            },
            updateImgUrl(type, item) {
                var params = {}
                if (type == 1) this.thresholdNow = item
                else this.ratioNow = item
                if (this.ratioNow == '200DPI') params.ratio = 0.3333
                else if (this.ratioNow == '300DPI') params.ratio = 0.5
                else if (this.ratioNow == '400DPI') params.ratio = 0.6667
                else params.ratio = 1.0
                this.$store.dispatch('clientGzwOrder/postCv3SealImgAlter', {
                    md5: this.md5Now,
                    threshold: this.thresholdNow,
                    ratio: params.ratio
                }).then(() => {
                    this.cv3ImgUrl = 'http://cv3.tubo.net/api/v1/ms/cv3/seal/img/' + this.md5Now + '?format=' + 'trans.png' + '&version=' + new Date().getTime()
                    this.$forceUpdate()
                })
            }
        },
        created() {
            if (this.$route.query.id) this.$store.dispatch('clientGzwOrder/getSealDetail', {id: this.$route.query.id}).then(() => {
                Object.assign(this.eSealPay,
                    {
                        eSealWxPaySan: api.baseUrl + api.gzwCusDz.dzPayWxScan + this.sealDetail.id + '?token=' + localStorage.getItem('pcCustomToken'),
                        eSealAliPayUrl: api.baseUrl + api.gzwCusDz.dzPayAlipayPc + this.sealDetail.id + '?token=' + localStorage.getItem('pcCustomToken')
                    }
                )
                this.keyActive = this.sealDetail.dzDeviceType
                this.eSeal.deliverType = this.sealDetail.deliverType == '01' ? 'method1' : 'method2'
                // this.$store.dispatch('clientGzwOrder/getSealImg',{id:this.$route.query.id}).then(payload => {
                //     this.sealImgUrl = _api.baseUrl + _api.client.cusGzwDz.sealImg + this.$route.query.id + '?token='  + store.state.user.user.token + '&version=' + new Date().getTime()
                // })
                // if(this.sealImgUrl.length == 0) this.typeActive == null
                this.$forceUpdate()
            })
            else this.$store.commit('clientGzwOrder/initSealDetail')
            if (this.$route.query.step) this.step = parseInt(this.$route.query.step)
            dict.dict('DictSocietySealsite_sealDzType').then(payload => this.sealDzTypeList = payload.content)
            dict.dict('DictStd_payType').then(payload => this.payTypeList = payload.content)
        }
    }
</script>

<style>
    .boxShadow {
        box-shadow: 0px 1px 11px #999;
    }
</style>
